import JessieOLP from './olp-jessie-min'

let OLP = JessieOLP.OLP;

(function () {
    function iosAvailable() {
        return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.olpApp;
    }

    OLP.requestNotificationPermission = function () {
        if (globalThis.AppInterface) {
            globalThis.AppInterface.requestNotificationPermission();
        } else if (iosAvailable()) {
            window.webkit.messageHandlers.olpApp.postMessage({"action": "requestNotificationPermission"});
        }
    };

    OLP.buyPremium = function (androidPremiumId, iosPremiumId) {
        if (globalThis.AppInterface) {
            globalThis.AppInterface.buyPremium(androidPremiumId)
        } else if (iosAvailable()) {
            window.webkit.messageHandlers.olpApp.postMessage({"action": "buyPremium", "premiumId": iosPremiumId});
        }
    };

    OLP.shareText = function (text) {
        if (globalThis.AppInterface) {
            globalThis.AppInterface.shareText(text)
            return true;
        } else if (iosAvailable()) {
            window.webkit.messageHandlers.olpApp.postMessage({"action": "shareText", "text": text});
            return true;
        }
        return false;
    };


})();
